import { IRankingExtendedSearch } from "src/api/server/extended-search.types";
import { getVisibleRankings } from "src/components/pages/search/components/rankings-dropdown-selector/utils/get-visible-rankings";
import { ISelectedRanking } from "../components/types";

interface IGetNextAvailableRankingParams {
    rankings: ReadonlyArray<IRankingExtendedSearch>;
    relevanceRanking: IRankingExtendedSearch;
    selectedFigures: ReadonlyArray<string>;
}

export const getNextAvailableRanking = ({ rankings, relevanceRanking, selectedFigures }: IGetNextAvailableRankingParams): ISelectedRanking => {
    const visibleRankings = getVisibleRankings(rankings, relevanceRanking, selectedFigures);

    const firstSortableRanking = visibleRankings.find(ranking => ranking.id !== null && ranking.id !== relevanceRanking.id);

    if (firstSortableRanking) {
        return { id: firstSortableRanking.id, sortDirection: firstSortableRanking.sortDirection };
    }

    return { id: relevanceRanking.id, sortDirection: relevanceRanking.sortDirection };
};
